import { Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import DashboardCard from "../../../ISSB/Dashboard/components/DashboardCard";
import LocalSpinner from "../../../../components/LocalSpinner";
import { getFormattedNumValue } from "../../../../utils";
import { TrendDown, TrendUp } from "@phosphor-icons/react";
import { useSearchParams } from "react-router-dom";

const SummaryCards = ({ currentYearData, previousYearData, isFetchingCurrentYear, isFetchingPreviousYear }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClick = (scope) => {
    const params = new URLSearchParams(searchParams);
    params.set("detailView", scope);
    setSearchParams(params);
  };

  return (
    <Grid templateColumns="repeat(3, 1fr)" gap={4} mb={6}>
      <GridItem>
        <ScopeCard
          title="Scope 1"
          currentYear={currentYearData?.scope1Total}
          previousYear={previousYearData?.scope1Total}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          onClick={() => handleClick("scopeOne")}
        />
      </GridItem>
      <GridItem>
        <ScopeCard
          title="Scope 2 - Location"
          currentYear={currentYearData?.scope2LocationTotal}
          previousYear={previousYearData?.scope2LocationTotal}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          onClick={() => handleClick("scopeTwo")}
        />
      </GridItem>
      <GridItem>
        <ScopeCard
          title="Scope 2 - Market"
          currentYear={currentYearData?.scope2MarketTotal}
          previousYear={previousYearData?.scope2MarketTotal}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          onClick={() => handleClick("scopeTwo")}
        />
      </GridItem>
      <GridItem>
        <ScopeCard
          title="Scope 1 & 2 - Market"
          currentYear={currentYearData?.scope1AndScope2MarketTotal}
          previousYear={previousYearData?.scope1AndScope2MarketTotal}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          // onClick={() => handleClick("scopeOneAndTwoMarket")}
        />
      </GridItem>
      <GridItem>
        <ScopeCard
          title="Scope 1 & 2 - Location"
          currentYear={currentYearData?.scope1AndScope2LocationTotal}
          previousYear={previousYearData?.scope1AndScope2LocationTotal}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          // onClick={() => handleClick("scopeOneAndTwoLocation")}
        />
      </GridItem>
      <GridItem>
        <ScopeCard
          title="Scope 3"
          currentYear={currentYearData?.scope3Total}
          previousYear={previousYearData?.scope3Total}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          // onClick={() => handleClick("scopeThree")}
        />
      </GridItem>
    </Grid>
  );
};

export const ScopeCard = ({
  title,
  currentYear,
  previousYear,
  currentLoading = false,
  previousLoading = false,
  onClick,
  theme = "light",
  calculatePercentageChange = true,
  unit = "tCO2e",
}) => {
  // Define local theme colors
  const colors = {
    light: {
      cardBg: "#F7FAFC",
      title: "teal",
      value: "gray.800",
      percentUp: "status.red",
      percentDown: "status.green",
      spinnerColor: "darkTeal",
    },
    dark: {
      cardBg: "pureBlack",
      title: "pureWhite",
      value: "lightLime",
      percentUp: "status.red",
      percentDown: "status.green",
      spinnerColor: "lightLime",
    },
  };

  const t = colors[theme] || colors.light;

  let percentageChange = previousYear;

  if (!calculatePercentageChange) {
  } else if (
    !currentLoading &&
    !previousLoading &&
    previousYear !== undefined &&
    currentYear !== undefined &&
    previousYear !== 0
  ) {
    percentageChange = ((currentYear - previousYear) / previousYear) * 100;
  }

  return (
    <DashboardCard onClick={onClick} bg={t.cardBg}>
      <Text fontSize="body.2xl" fontWeight="bold" color={t.title}>
        {title}
      </Text>
      {currentLoading ? (
        <LocalSpinner size="sm" color={t.spinnerColor} />
      ) : (
        <Heading>
          <Text as="span" fontSize="heading.2xl" fontWeight="bold" color={t.value}>
            {getFormattedNumValue(currentYear, 2, true) || 0}
          </Text>{" "}
          <Text as="span" fontSize="body.m" color={t.value}>
            {unit}
          </Text>
        </Heading>
      )}
      {previousLoading ? (
        <LocalSpinner size="sm" color={t.spinnerColor} />
      ) : (
        <Text
          fontSize="heading.s"
          display="flex"
          fontWeight="bold"
          alignItems="center"
          gap={1}
          color={percentageChange >= 0 ? t.percentUp : t.percentDown}
        >
          {percentageChange >= 0 ? <TrendUp size={18} weight="bold" /> : <TrendDown size={18} weight="bold" />}
          {getFormattedNumValue(percentageChange, 2) || 0} %
        </Text>
      )}
    </DashboardCard>
  );
};

export default SummaryCards;
